import { useBreakpoint } from '@vivino/js-react-common-ui';
import React from 'react';

import { Col, Row } from 'vivino-ui/components/Grid';

import styles from './tasteCharacteristics.skeleton.scss';

const TasteCharacteristicsSkeleton = () => {
  const { isMobile, isTablet } = useBreakpoint();
  return (
    <div className={styles.tasteCharacteristics}>
      <Row>
        <Col>
          <div className={styles.tasteHeader} />
        </Col>
      </Row>
      <Row>
        <Col desktop={8} tablet={8} mobile={6}>
          <div className={styles.structureBar} />
          <div className={styles.structureBar} />
          <div className={styles.structureBar} />
          <div className={styles.structureBar} />
        </Col>
        {!isMobile && (
          <Col desktop={4} tablet={4}>
            <div className={styles.structureHeader} />
          </Col>
        )}
      </Row>
      <Row>
        <Col desktop={4} tablet={6} mobile={6}>
          <div className={styles.noteCard} />
        </Col>
        <Col desktop={4} tablet={6} mobile={6}>
          <div className={styles.noteCard} />
        </Col>
        {!isTablet && (
          <Col desktop={4} mobile={6}>
            <div className={styles.noteCard} />
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TasteCharacteristicsSkeleton;
